// @ts-nocheck

import React from "react";
import { FormElement } from "../internal/JobApplicationBuilder/types";
import { v4 as uuidv4 } from "uuid";

interface ToolboxProps {
  onAddElement: (element: FormElement) => void;
}

const Toolbox3: React.FC<ToolboxProps> = ({ onAddElement }) => {
  const allOtherElements: FormElement[] = [
    {
      id: uuidv4(),
      type: "text",
      label: "Text",
      headerText: "Sample Text",
      Description: "Enter your description here ..",
      icon: "T",
      placeholder: "Enter your details",
    },
    {
      id: uuidv4(),
      type: "long_text",
      label: "Long Text",
      headerText: "Sample Long Text",
      Description: "Enter your description here ..",
      icon: "L",
      placeholder: "Enter your details",
    },
    {
      id: uuidv4(),
      type: "number",
      label: "Number",
      headerText: "Sample Number",
      icon: "N",
      placeholder: "Enter a number",
    },
    {
      id: uuidv4(),
      type: "single_select",
      label: "Dropdown Single",
      headerText: "Sample Single Dropdown",
      Description: "Enter your description here ..",
      icon: "D",
      options: [
        { id: uuidv4(), label: "Strongly disagree", selected: false },
        { id: uuidv4(), label: "Disagree", selected: false },
        { id: uuidv4(), label: "Neither agree nor disagree", selected: false },
        { id: uuidv4(), label: "Agreement", selected: false },
        { id: uuidv4(), label: "Strongly agree", selected: false },
      ],
    },
    {
      id: uuidv4(),
      type: "multi_select",
      label: "Dropdown Multi",
      headerText: "Sample Multi Dropdown",
      Description: "Enter your description here ..",
      icon: "D",
      options: [
        { id: uuidv4(), label: "Strongly disagree", selected: false },
        { id: uuidv4(), label: "Disagree", selected: false },
        { id: uuidv4(), label: "Neither agree nor disagree", selected: false },
        { id: uuidv4(), label: "Agreement", selected: false },
        { id: uuidv4(), label: "Strongly agree", selected: false },
      ],
    },
    {
      id: uuidv4(),
      type: "rating",
      label: "Rating",
      headerText: "Sample Rating Number",
      icon: "R",
      placeholder: "Enter a rating",
      Description: "Enter your rating here ..",
      options: [
        { id: uuidv4(), label: "1", selected: false },
        { id: uuidv4(), label: "2", selected: false },
        { id: uuidv4(), label: "3", selected: false },
        { id: uuidv4(), label: "4", selected: false },
        { id: uuidv4(), label: "5", selected: false },
      ],
    },

    {
      id: uuidv4(),
      type: "tags",
      label: "Tag",
      headerText: "Sample Tag",
      Description: "Enter your description here ..",
      icon: "D",
    },
  ];

  return (
    <div className="p-0 w-full bg-transparent">
      <div>
        <h3 className=" text-wedges-gray text-[13px] font-medium mb-2  pt-3">
          Input
        </h3>
        <ul>
          {allOtherElements.map((element) => (
            <li
              key={element.id}
              onClick={() => onAddElement(element)}
              className="flex items-center py-[6px] px-3 mb-2 cursor-pointer border border-solid border-gray-300 rounded hover:bg-gray-200"
            >
              <span className="mr-2 text-dark-black-200 text-[13px] font-normal">
                {element.icon}
              </span>
              <span className="text-dark-black-200 text-[13px] font-normal">
                {element.label}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Toolbox3;
